// Two overlapping native range inputs with a colored fill between them.
// Enforces low <= high on every input event.
export function createDualRange({ min, max, step, low, high, onChange }) {
  const wrap = document.createElement("span");
  wrap.className = "slider bipolar dual";

  const inLo = document.createElement("input");
  const inHi = document.createElement("input");
  for (const el of [inLo, inHi]) {
    el.type = "range";
    el.min = String(min);
    el.max = String(max);
    el.step = String(step);
  }
  inLo.className = "lo";
  inHi.className = "hi";
  inLo.value = String(low);
  inHi.value = String(high);

  const fill = document.createElement("span");
  fill.className = "dual-fill";

  wrap.append(fill, inLo, inHi);

  function applyFill() {
    const lo = parseFloat(inLo.value);
    const hi = parseFloat(inHi.value);
    const loPct = ((lo - min) / (max - min)) * 100;
    const hiPct = ((hi - min) / (max - min)) * 100;
    wrap.style.setProperty("--lo", loPct + "%");
    wrap.style.setProperty("--hi", hiPct + "%");
  }
  applyFill();

  inLo.addEventListener("input", () => {
    if (parseFloat(inLo.value) > parseFloat(inHi.value)) {
      inLo.value = inHi.value;
    }
    applyFill();
    onChange?.({ low: parseFloat(inLo.value), high: parseFloat(inHi.value), changed: "low" });
  });
  inHi.addEventListener("input", () => {
    if (parseFloat(inHi.value) < parseFloat(inLo.value)) {
      inHi.value = inLo.value;
    }
    applyFill();
    onChange?.({ low: parseFloat(inLo.value), high: parseFloat(inHi.value), changed: "high" });
  });

  return {
    el: wrap,
    inputs: { lo: inLo, hi: inHi },
    setLow(v)  { inLo.value = String(v); applyFill(); },
    setHigh(v) { inHi.value = String(v); applyFill(); },
  };
}
